export default __webpack_public_path__ + "static/media/cms-logo.82e74f15.png";